import React from "react";
import styles from "./GalleryAmigurumis.module.css";
import oso0 from "../data/assets/Amigurumis/Oso/0.png";
import oso1 from "../data/assets/Amigurumis/Oso/2.png";
import dino0 from "../data/assets/Amigurumis/Dino/1.png";
import perro from "../data/assets/Amigurumis/PerroSalchicha/2.png";
import pulpo0 from "../data/assets/Amigurumis/pulpo:medusa/0.png";
import pulpo1 from "../data/assets/Amigurumis/pulpo:medusa/2.png";
import minidino0 from "../data/assets/Amigurumis/MinoDino/1.png";

function GalleryAmigurumis() {
  const data = [oso0, dino0, pulpo0, oso1, pulpo1, perro, minidino0];
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Amigurumis</h2>
      <div className={styles.gallery}>
        {data.map((item, i) => (
          <figure className={styles.item} key={i}>
            <img src={item} alt="foto" className={styles.image}></img>
          </figure>
        ))}{" "}
      </div>
    </div>
  );
}

export { GalleryAmigurumis };
